import { createStructuredSelector } from "reselect";
import { selectFundName } from "../../../../Epics/MyAccounts/selectors";

const getNeedAssistanceStates = data => data.needAssistance;

const getvisible = data => {
  const { visibility } = getNeedAssistanceStates(data);
  return visibility;
};

const getdrawerCondition = data => {
  const { toUpdate } = getNeedAssistanceStates(data);
  return toUpdate;
};

// need Assistance
export const needAssistanceDerivedStates = createStructuredSelector({
  visible: getvisible,
  drawerCondition: getdrawerCondition,
  fundName: selectFundName
});
